module.exports = __webpack_public_path__ + "img/additional_insurance_cap.9ade64da.svg";